module.exports = __webpack_public_path__ + "04_bob_beige.f77479b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/04_bob_beige.png
// module id = I8nQ
// module chunks = 0